// extracted by mini-css-extract-plugin
module.exports = {"footerSection":"Footer_footerSection__1XOpj","copyright":"Footer_copyright__upj2g","menu":"Footer_menu__SZs-c"};